import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { InsuranceAddMembersPage } from '@/common/containers/Dashboard/Insurance/InsuranceAddMembersPage/InsuranceAddMembersPage';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { safeLazy } from '@/common/utils/import';

const { AddInsuranceMembers } = safeLazy(
  () => import('@/web/containers/Insurance/Insurance')
);

export default function Page() {
  const {
    features: { ff_family_inclusion_simulation },
  } = useFeatures();
  return (
    <RouterSuspense>
      {ff_family_inclusion_simulation ? (
        <InsuranceAddMembersPage />
      ) : (
        <AddInsuranceMembers />
      )}
    </RouterSuspense>
  );
}
